module.exports = __webpack_public_path__ + "static/media/no-more-image.e76fd10c.png";